<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/modules/auth/stores/auth-store'
import { useWorkspaceStore } from '@/modules/workspace/stores/workspace-store'
import TheAppBanners from '@/modules/shared/components/the-app-banners.vue'
import TheSidenav from '@/modules/shared/components/the-sidenav.vue'

const authStore = useAuthStore()
const workspaceStore = useWorkspaceStore()

const isBannerVisible = computed(
  () => workspaceStore.current.options.is_setup_mode_enabled && authStore.is_site_or_group_admin,
)
</script>

<template>
  <TheAppBanners />
  <div
    class="fixed inset-0 top-[58px] flex overflow-hidden bg-white"
    :class="isBannerVisible ? 'sm:top-8' : 'sm:top-0'"
  >
    <TheSidenav />
    <main class="h-full flex-grow overflow-y-scroll bg-white">
      <div class="mb-8 mt-6 px-3 py-6 sm:mx-12">
        <slot></slot>
      </div>
    </main>
  </div>
</template>
